import React, { useMemo } from 'react'
import { Modal, message } from 'antd'
import B2BLayout from '../../layouts/b2b'
import { useFetchData } from './hooks/useFetchData'
import { SystemInfo } from './components/SystemInfo'
import { QueueStats } from './components/QueueStats'
import { ActiveRequests } from './components/ActiveRequests'
import { Connections } from './components/Connections'
import { ActionButtons } from './components/ActionButtons'
import { PageWrapper, PageTitle } from './styles'

const EmailMonitor: React.FC = () => {
  const {
    status,
    connections,
    loading,
    autoRefresh,
    setAutoRefresh,
    refreshAll,
    cleanupStuck,
    clearConnections,
    retryFailed
  } = useFetchData()

  const breadcrumbs = useMemo(() => [
    {
      href: '/admin',
      title: 'Админ панель'
    },
    {
      href: '/admin/email-monitor',
      title: 'Мониторинг почтовых отправок'
    }
  ], [])

  const handleRetryFailed = () => {
    Modal.confirm({
      title: 'Повторить отправку неудачных писем?',
      content: 'Будут повторно отправлены все неудачные письма за последние 24 часа',
      onOk: async () => {
        try {
          const result = await retryFailed()
          message.success(`Повторная отправка запущена для ${result.count} писем`)
          refreshAll()
        } catch (error) {
          message.error('Ошибка повтора отправки')
        }
      }
    })
  }

  return (
    <B2BLayout breadcrumbs={breadcrumbs}>
      <PageWrapper>
        <PageTitle>Мониторинг почтовых отправок</PageTitle>

        <ActionButtons
          loading={loading}
          autoRefresh={autoRefresh}
          onRefresh={refreshAll}
          onCleanupStuck={cleanupStuck}
          onClearConnections={clearConnections}
          onToggleAutoRefresh={() => setAutoRefresh(!autoRefresh)}
        />

        <SystemInfo status={status} />

        <QueueStats status={status} onRetryFailed={handleRetryFailed} />

        <ActiveRequests status={status} />

        <Connections connections={connections} />
      </PageWrapper>
    </B2BLayout>
  )
}

export default EmailMonitor

